
import * as React from "react";
import { Sheet, SheetContent } from "@/components/ui/sheet";

interface SidebarMobileProps {
  side: "left" | "right";
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  width: string;
  children: React.ReactNode;
}

export const SidebarMobile = React.forwardRef<
  HTMLDivElement,
  SidebarMobileProps & Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>
>(({
  side,
  openMobile,
  setOpenMobile,
  width,
  children,
  ...props
}, ref) => {
  // Add debug log to track openMobile state changes
  React.useEffect(() => {
    console.log("SidebarMobile rendered with openMobile:", openMobile);
  }, [openMobile]);

  return (
    <Sheet open={openMobile} onOpenChange={setOpenMobile}>
      <SheetContent
        ref={ref}
        data-sidebar="sidebar"
        data-mobile="true"
        className="w-[--sidebar-width] bg-background dark:bg-card border-sidebar-border p-0 text-sidebar-foreground [&>button]:hidden"
        style={
          {
            "--sidebar-width": width,
          } as React.CSSProperties
        }
        side={side}
        {...props}
      >
        <div className="flex h-full w-full flex-col bg-background dark:bg-card">{children}</div>
      </SheetContent>
    </Sheet>
  );
});

SidebarMobile.displayName = "SidebarMobile";
